import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <footer className="bsc-footer">
      <div className="footer-text">&copy; Bluestone Comics</div>
    </footer>
  );
};
export default Footer;
